import { ApiCall } from './CustomHooks';
import PopupWithIcon from './Popups';
import { GetSession } from './criptoUtils';
import { store } from '../../Redux/store';

let baseUrl;
if (window.location.hostname.indexOf("react.") >= 0 || window.location.hostname.indexOf("megacalibre.") >= 0) {
    baseUrl = `${window.location.protocol}//${window.location.host}/${window.location.pathname.split('/')[1]}`;
} else {
    baseUrl = `${window.location.protocol}//${window.location.host}`;
}
const virtualPath = baseUrl;

const autoCompleteDelay = 300;
export { autoCompleteDelay, virtualPath };

var user = GetSession('cookies', 'user');
const config = {
    AuthToken: process.env.REACT_APP_SECRET_KEY,
    LoginToken: user?.loginToken ? user?.loginToken : null,
    UserCode: user?.loginUserCode ? user?.loginUserCode : null,
    UserName: user?.loginUserName ? user?.loginUserName : null,
    loginUserGroupID: user?.loginUserGroupID ? user?.loginUserGroupID : null,
}

export default config;

export const setCookie = (name, value, days) => {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

export const deleteCookie = (name) => {
    setCookie(name, "", -1);
};

export const CommonApiData = () => {
    const authToken = process.env.REACT_APP_E_KEY;
    var user = GetSession('cookies', 'user');
    const state = store.getState();
    const branch = state.header.branchCode;
    const branchCode = branch ? branch.split(':')[0].trim() : '';
    if (user) {
        let data = {
            authToken: String(authToken ?? ''),
            loginUserCode: String(user.loginUserCode ?? ''),
            loginUserClientCode: String(user.loginUserClientCode ?? ''),
            loginToken: String(user.token ?? ''),
            userName: String(user.userName ?? ''),
            loginUserBCode: String(branchCode ?? ''),
            loginUserBName: String(user.bName ?? ''),
            companyCode: String(user.companyCode ?? ''),
            isPcsMultiply: user?.isPcsMultiply
        }
        return data
    } else {
        let data = {
            AuthToken: String(authToken ?? ''),
        }
        return data
    }
}

export const initializeFilterData = {
    "SearchText": "",
    "StartValue": "2",
    "SearchFieldValue": "",
    "PageSize": "10",
    "AdvanceFilter": []
}

//-------------Data Copy to clipboard------------//
export const copyToClipboard = (text) => {
    var textField = document.createElement('textarea')
    textField.innerText = text
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
};

//------------------Get Financial Year Data-----------------//
export const getCurrentFinancialYear = () => {
    const launchYear = 2023; // Default Lauch Year
    const today = new Date(); // current Date
    const month = today.getMonth(); //current Month
    const currentYear = today.getFullYear(); // Current Year
    let financialYearArr = [];
    for (let i = 0; i <= (currentYear - launchYear); i++) {
        if ((month + 1) <= 3) {
            financialYearArr.push({
                value: `${(currentYear - i - 1)}-${(currentYear - i)}`,
                label: `${(currentYear - i - 1)}-${(currentYear - i).toString().slice(-2)}`,
            })
        } else {
            financialYearArr.push({
                value: `${(currentYear - i)}-${(currentYear - i + 1)}`,
                label: `${(currentYear - i)}-${(currentYear - i + 1).toString().slice(-2)}`
            })
        }
    }
    return { financialYearArr, currentYear: (month + 1) <= 3 ? (currentYear - 1) + "-" + currentYear : currentYear + "-" + (currentYear + 1) }
}

//--------------------Convent base 64 To Blob-------------------------//
export const base64ToBlob = (base64, type = "application/octet-stream") => {
    const binStr = atob(base64);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], { type: type });
}

//---------------Convert JSON into Array -----------------//
export const JSONToArray = (data, columns) => {

    //--- Convert object keys to an array ---//
    const keysArray = Object.keys(data);

    //--- Extract key-value pairs ---//
    const keyValuePairs = keysArray.map(key => [key, data[key]]);

    //--- division the array into pairs of key-value pairs and no. of column in a row ---//
    const keyValuePairsData = [];
    for (let i = 0; i < keyValuePairs.length; i += columns) {
        keyValuePairsData.push(keyValuePairs.slice(i, i + columns));
    }

    return keyValuePairsData
}

export const capitalizeFirstLetter = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
}

//---------------Convert Array to  no. of columns in table -----------------//
export const ArrayToRows = (data, columns) => {

    //--- division the array into pairs of key-value pairs and no. of column in a row ---//
    const keyValuePairsData = [];
    for (let i = 0; i < data.length; i += columns) {
        keyValuePairsData.push(data.slice(i, i + columns));
    }

    return keyValuePairsData
}

//------  Show File ------------//
export const handleShowFile = async (payload, url) => {
    try {
        let imgresult = await ApiCall(url || '/api/Image/GetImage', { ...payload });
        let result = imgresult.imageDetails;
        if (result.imageExt === 'pdf') {
            const blob = base64ToBlob(result?.imageBase64/*?.split(",")[1]*/, 'application/pdf');
            const url = URL.createObjectURL(blob);
            const pdfWindow = window.open(url, '_blank');
            if (!pdfWindow) {
                throw new Error("Please allow pop-ups for this site");
            }
            pdfWindow.document.title = "View PDF";
        }
        else if (result.imageExt === 'down') {
            const link = document.createElement('a');
            link.href = `data:image/jpeg;base64,${result.imageBase64}`;
            link.download = 'image.jpg';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        else {
            const blob = base64ToBlob(result?.imageBase64/*?.split(",")[1]*/, 'image/jpeg');
            const url = URL.createObjectURL(blob);
            const imageWindow = window.open(url, '_blank');
            if (!imageWindow) {
                throw new Error("Please allow pop-ups for this site");
            }
            imageWindow.document.title = "View Image";
        }
    } catch (error) {
        console.error('Error handling file:', error);
    }
}

//----- Download file -----//
export const handleDownload = async (payload, url) => {
    try {
        let imgResult = await ApiCall(url || '/api/Image/GetImage', { ...payload });

        if (imgResult?.imageDetails?.imageBase64) {
            const base64String = imgResult.imageDetails.imageBase64/*.split(",")[1]*/.trim();
            const contentType = imgResult?.imageDetails?.contentType || 'application/octet-stream';
            const dataURI = `data:${contentType};base64,${base64String}`;
            const link = document.createElement("a");
            link.href = dataURI;
            link.download = imgResult?.imageDetails?.imageExt.toUpperCase() === 'PDF' ? "file.pdf" : 'image.jpg';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            console.error("Base64 string is empty or undefined.");
        }
    } catch (error) {
        console.error("Error while handling download:", error);
    }
};

export const handleShowDocFile = async (payload, url) => {
    try {
        let imgresult = await ApiCall(url || "/api/CandidateOperation/GetCandidateDocuments", { ...payload });
        let result = imgresult.documentsDetails;
        if (result.docExt === 'pdf') {
            const blob = base64ToBlob(result?.docBase64/*?.split(",")[1]*/, 'application/pdf');
            const url = URL.createObjectURL(blob);
            const pdfWindow = window.open(url, '_blank');
            if (!pdfWindow) {
                throw new Error("Please allow pop-ups for this site");
            }
            pdfWindow.document.title = "View PDF";
        }
        else if (result.docExt === 'down') {
            const link = document.createElement('a');
            link.href = `data:image/jpeg;base64,${result.docBase64}`;
            link.download = 'image.jpg';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        else {
            const blob = base64ToBlob(result?.docBase64/*?.split(",")[1]*/, 'image/jpeg');
            const url = URL.createObjectURL(blob);
            const imageWindow = window.open(url, '_blank');
            if (!imageWindow) {
                throw new Error("Please allow pop-ups for this site");
            }
            imageWindow.document.title = "View Image";
        }
    } catch (error) {
        console.error('Error handling file:', error);
    }
}

//----- Download file -----//
export const handleDocDownload = async (payload, url) => {
    try {
        let imgResult = await ApiCall(url || "/api/CandidateOperation/GetCandidateDocuments", { ...payload });

        if (imgResult?.documentsDetails?.docBase64) {
            const base64String = imgResult.documentsDetails.docBase64/*.split(",")[1]*/.trim();
            const contentType = imgResult?.documentsDetails?.contentType || 'application/octet-stream';
            const dataURI = `data:${contentType};base64,${base64String}`;
            const link = document.createElement("a");
            link.href = dataURI;
            link.download = imgResult?.documentsDetails?.docExt.toUpperCase() === 'PDF' ? "file.pdf" : 'image.jpg';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            console.error("Base64 string is empty or undefined.");
        }
    } catch (error) {
        console.error("Error while handling download:", error);
    }
};

//---------- get File Name and Extension --------------//
export const getFileNameAndExtension = (fileName) => {
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1) {
        console.log("No extension found");
    } else {
        const name = fileName.substring(0, lastDotIndex); // capture the Name of Uploaded file
        const extension = fileName.substring(lastDotIndex + 1); // capture the Extension of Uploaded file
        return { name, extension }
    }
}

export function logout() {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var equalsPos = cookie.indexOf("=");
        var name = equalsPos > -1 ? cookie.substr(0, equalsPos) : cookie;

        document.cookie = name + "=; Max-Age=-99999999;";
    }
}

export function ConvertToBlobImage(value, newWindow = false) {
    // Convert base64-encoded string to binary string
    const binStr = atob(value);
    const len = binStr.length;

    // Create a Uint8Array to hold the binary data
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
    }

    // Create a Blob object from the binary array, specifying the image MIME type
    const imageBlob = new Blob([arr], { type: 'image/png' });

    // Generate a URL for the Blob and store it in sessionStorage
    const url = URL.createObjectURL(imageBlob);
    sessionStorage.setItem('imageBlobUrl', url);

    // Open a new window or tab based on the 'newWindow' flag
    if (newWindow) {
        window.open(virtualPath + '/ImageView', 'ImageWindow', 'width=800,height=600,scrollbars=yes,resizable=yes');
    } else {
        window.open(virtualPath + '/ImageView', '_blank');
    }
}

export const Box = (props) => {
    const { children, heading, customPadding, heading_title, heading_color, headingClassname, InfoDetails, addon_heading, boxMainDivClass, boxMainDivStyle, headingBordercolor = '', headBorder = '', boxBorder = false, boxBorderColor = '', headingIcon, borderTopColor,
        borderTop = '0', borderRight = '0', borderLeft = '0', borderBottom = '0', height = "auto", ref, rest, openBox, setOpenBox, toggleOpenBox = false
    } = props

    return (
        <div className={`${customPadding ? customPadding : "pt-3"} ${boxMainDivClass} `} style={boxMainDivStyle} ref={ref} {...rest}>
            <div className="main-card rounded-2" style={boxBorder ? { borderTop: borderTopColor && `2px solid ${borderTopColor}`, borderWidth: `${borderTop}px ${borderRight}px ${borderBottom}px ${borderLeft}px`, borderStyle: "solid", borderColor: boxBorderColor || headingBordercolor } : { borderTop: borderTopColor && `2px solid ${borderTopColor}` }}>
                {heading && <div onClick={toggleOpenBox ? (() => setOpenBox(!openBox)) : undefined}
                    className={`headingstyle heading_textsize position-relative ${headingClassname} ${addon_heading ?
                        "d-lg-flex d-md-flex d-sm-flex gap-2" :
                        ""} `}
                    style={toggleOpenBox ? { background: "var(--bg-light)", cursor: "pointer" } : {}}>
                    <h6 style={heading_title && headingBordercolor ? {
                        display: "inline",
                        background: headingBordercolor,
                        //  border: "2px solid #33CCFF",
                        borderRadius: "7px 24px 24px 7px",
                        padding: "1px 15px",
                        position: "relative",
                        left: "-20px",
                        top: "-8px"
                    } : { display: "inline" }}>{headingIcon && <i className={headingIcon} style={{ zIndex: "100000" }}></i>}{heading_title}</h6>{addon_heading && addon_heading}
                    {InfoDetails && <div className={'InfoHeadingDiv ps-2'}> <PopupWithIcon InfoDetails={InfoDetails} /> </div>}
                    {toggleOpenBox && <div className='box_toggle_button' ><i onClick={() => setOpenBox(!openBox)} className={openBox ? 'fa-solid fa-chevron-up arrow p-1' : 'fa-solid fa-chevron-down arrow p-1'}></i></div>}

                </div>
                }
                {toggleOpenBox ?
                    <div className={`${openBox ? 'collapse show pb-2' : 'collapsed'}`} style={openBox ? { height: height, transition: 'all ease-in 0.6s', } : { height: '0px', transition: 'all ease-in 0.6s' }}>
                        {openBox && children}
                    </div>
                    :
                    <div className={``} style={{ height: height, transition: 'all ease-in 0.6s', }}>
                        {children}
                    </div>
                }

            </div>
        </div>
    )
}
